export const settingsTranslationEN = {
  settings: {
    "title": "Settings",
    'preferences': 'Preferences',
    "account": "Account"
  }
}